import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import TrayHeader from '../../../../components/Tray/TrayHeader';
import { selectCreateInsuredStep } from '../../../../redux/modules/insured';
import { jobSearch } from '../../../../redux/modules/jobSearch';
import { globalRequirementTemplateBuilder } from '../../../../redux/reducer';

import AddToProjectForm from './AddToProjectForm';
import CreateInsuredForm from './CreateInsuredForm';

const CreateInsuredTray = ({ companyId }) => {
  const dispatch = useDispatch();
  const activeStep = useSelector(selectCreateInsuredStep);

  const titles = {
    0: 'Create New Insured',
    1: 'Add to Project?'
  };

  useEffect(() => () => {
    dispatch(globalRequirementTemplateBuilder.resetRequirementTemplateState());
    dispatch(jobSearch.updateGlobalSearchFilter(''));
  }, []);

  const renderContent = () => {
    if (activeStep === 0) return <CreateInsuredForm companyId={companyId} />;

    if (activeStep === 1) return <AddToProjectForm />;
  };

  return (
    <>
      <TrayHeader title={titles[activeStep]} />
      {renderContent()}
    </>
  );
};

CreateInsuredTray.propTypes = { companyId: PropTypes.number.isRequired };

export default CreateInsuredTray;
